export default function serial(maxId = Number.MAX_SAFE_INTEGER) {
  let currentId = 0

  return {
    next: () => {
      if (currentId >= maxId) {
        currentId = 0
      }
      return currentId++
    },
  }
}
